const ITEMS = [
  "FAHRDIENSTE",
  "ÜBERFÜHRUNGEN",
  "REINIGUNG",
  "FAHRZEUGPFLEGE",
  "HOL- & BRINGSERVICE",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#0a0a0a] py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-4xl sm:text-6xl font-black tracking-widest text-stroke px-8">
              {item}
            </span>
            <span className="text-[#0052ff] text-3xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
